import LabelImportantOutlinedIcon from "@mui/icons-material/LabelImportantOutlined";
import { Button } from "@mui/material";
import type { GridRowSelectionModel } from "@mui/x-data-grid-premium";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedRowIdsFromModel } from "@entrilia/shared/components/grid/gridHelper";
import { markAsImportantUpdatingSelector, messagesSelector } from "../../../../../store/state/messages/selectors";
import { markAsImportant } from "../../../../../store/state/messages/thunks";
import { impersonationSelector } from "../../../../../store/state/user/selectors";
import type { AppDispatch } from "../../../../../store/store";

interface Props {
  compact?: boolean;
  selection: GridRowSelectionModel;
}

export const MarkAsImportantAction = (props: Props) => {
  const { compact, selection } = props;

  const dispatch: AppDispatch = useDispatch();

  const messages = useSelector(messagesSelector);
  const markAsImportantUpdating = useSelector(markAsImportantUpdatingSelector);
  const isImpersonation = useSelector(impersonationSelector);

  const anyNotImportantMessagesInSelected = useMemo(() => {
    return !!messages.find((msg) => selection.ids.has(msg.id) && !msg.isImportant);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [messages, selection, markAsImportantUpdating]);

  const changeSelectedMessagesImportance = useCallback(
    (isImportant: boolean) => {
      dispatch(markAsImportant(getSelectedRowIdsFromModel(selection), isImportant));
    },
    [dispatch, selection]
  );

  const allowMarkAsImportantAction = useMemo(() => {
    return selection && selection.ids.size > 0 && anyNotImportantMessagesInSelected;
  }, [selection, anyNotImportantMessagesInSelected]);

  return (
    <>
      {allowMarkAsImportantAction && (
        <Button
          disabled={isImpersonation}
          startIcon={<LabelImportantOutlinedIcon sx={(t) => ({ color: t.palette.warning.light })} />}
          loadingPosition="start"
          loading={markAsImportantUpdating}
          onClick={() => changeSelectedMessagesImportance(true)}
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            flexDirection: compact === true ? "column" : "inherit",
          })}
        >
          Important
        </Button>
      )}
    </>
  );
};

export default MarkAsImportantAction;
